import React from 'react';
import { AnalyticsDashboard } from '~/components/predict/analytics';

/**
 * Discharge Analytics View
 *
 * Analytics and reporting dashboards for discharge operations
 * Displays role-based dashboards (Ops, Manager, Executive)
 */
const PredictKPIs: React.FC = () => {
  return <AnalyticsDashboard />;
};

export default PredictKPIs;
